module.exports = new __parcel__URL__("nighttime-lights-ej--dataset-cover-neworleans.1209360f.jpeg").toString();